module.exports = __webpack_public_path__ + "img/hero-lg.70eb84c0.png";